<template>
  <div class="flex flex-col gap-6">
    <section
      v-for="section in sections"
      :id="section.id"
      :key="section.id"
      class="flex flex-col gap-2"
    >
      <JoszakiHeading :level="2">{{ section.heading }}</JoszakiHeading>
      <template v-for="(item, index) in section.items">
        <p v-if="item.type === 'text'" :key="index">{{ item.value }}</p>
        <ol
          v-else-if="item.type === 'quotes'"
          :key="index"
          class="flex flex-col gap-2 list-decimal pl-6"
        >
          <li v-for="(quote, quoteIndex) in item.value" :key="quoteIndex">
            <q class="italic">{{ quote }}</q>
          </li>
        </ol>
        <ul
          v-else-if="item.type === 'cityLinks'"
          :key="index"
          class="flex flex-wrap gap-x-4 gap-y-1"
        >
          <li v-for="city in item.value" :key="city.id">
            <NuxtLink
              class="text-primary hover:underline"
              :to="cityPath(city)"
            >
              {{ page.professionTask.name }} {{ city.name }}
            </NuxtLink>
          </li>
        </ul>
      </template>
    </section>
  </div>
</template>

<script>
import { professionTaskPagePath } from "./professionTaskPageOutcome";

export default {
  name: "ProfessionTaskCityContent",
  props: {
    page: {
      type: Object,
      required: true,
    },
    sections: {
      type: Array,
      required: true,
    },
  },
  methods: {
    cityPath(city) {
      return professionTaskPagePath(this.localePath, {
        slug: this.page.slug,
        citySeoName: city.seoName,
      });
    },
  },
};
</script>
